module.exports = __webpack_public_path__ + "static/media/technological.73c763d3.png";